module.exports = __webpack_public_path__ + "img/data-icon-2.88128fb3.png";